import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalButton from './modalButton.component';

interface modalButtonCreateUpdateProps {
  onCreateClick?: () => void;
  onUpdateClick?: () => void;
  iconCreate?: React.ReactNode;
  iconUpdate?: React.ReactNode;
  disable?: boolean;
  create: boolean;
}

const ModalButtonCreateUpdate: React.FC<modalButtonCreateUpdateProps> = ( {
  onCreateClick,
  onUpdateClick,
  iconCreate,
  iconUpdate,
  disable = false,
  create,
} ) => {
  const { t } = useTranslation();
  const showButton = create ? onCreateClick : onUpdateClick;

  if ( !showButton ) {return null;}

  return (
    <ModalButton
      label={create ? t( 'common:create' ) : t( 'common:update' )}
      textColor="text-white"
      shadow="shadow-none"
      bgColor="bg-blue-500 hover:bg-blue-600"
      borderColor={`${!disable && 'border-blue-500'}`}
      hoverBorderColor="hover:border-blue-600"
      width="w-fit"
      onClick={create ? onCreateClick : onUpdateClick}
      icon={create ? iconCreate : iconUpdate}
      disable={disable}
    />
  );
};

export default ModalButtonCreateUpdate;
